var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgForm = function SvgForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "form")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8680D8",
    d: "M43,47H24c-0.552,0-1-0.448-1-1v-8c0-0.552,0.448-1,1-1h19c0.552,0,1,0.448,1,1v8C44,46.552,43.552,47,43,47 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M43,33H5c-0.552,0-1-0.448-1-1V14c0-0.552,0.448-1,1-1h38c0.552,0,1,0.448,1,1v18C44,32.552,43.552,33,43,33 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    fill: "#FFFFFF",
    width: 36,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M43,9H5C4.448,9,4,8.552,4,8V2c0-0.552,0.448-1,1-1h38c0.552,0,1,0.448,1,1v6C44,8.552,43.552,9,43,9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    fill: "#FFFFFF",
    width: 36,
    height: 4
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/form.f7905706.svg";
export { ForwardRef as ReactComponent };